{
	"back": "Torna al monitoraggio dei bandi",
	"cause": {
		"dsu_quota.reconciled": "Controllo notturno: variazione non registrata da un fatto",
		"offer.accepted": "Offerta accettata",
		"offers.launched": "Avvio delle offerte",
		"ranking.calculated": "Graduatoria calcolata di nuovo",
		"residence.funded_beds_corrected": "Posti ammessi a finanziamento corretti"
	},
	"error": "Non è stato possibile caricare la quota DSU. Ricarica la pagina.",
	"export": "Esporta prospetto della quota DSU",
	"figures": {
		"below_threshold": "Sotto soglia",
		"dsu_seats": "Posti a tariffa DSU",
		"funded_beds": "Posti ammessi a finanziamento",
		"gap": "Differenza",
		"gap_missing_one": "Manca {{count}} posto",
		"gap_missing_other": "Mancano {{count}} posti",
		"gap_none": "Nessuna, la quota è in linea",
		"missing_data_admin": "Dato mancante: inserisci i posti ammessi a finanziamento nella scheda della struttura.",
		"missing_data_manager": "Dato mancante: chiedi all'admin generale di inserire i posti ammessi a finanziamento.",
		"open": "Apri la quota DSU",
		"summary": "Quota DSU: {{seats}} su {{threshold}} richiesti",
		"summary_no_threshold": "Quota DSU: {{seats}} posti a tariffa DSU",
		"threshold": "Soglia richiesta",
		"title": "Quota DSU"
	},
	"history": {
		"columns": {
			"cause": "Causa",
			"date": "Data",
			"dsu_seats": "Posti DSU",
			"threshold": "Soglia",
			"uncovered": "Non coperti"
		},
		"empty": "Nessuna variazione registrata.",
		"line": "{{seats}} posti DSU, soglia {{threshold}}, {{uncovered}} non coperti",
		"title": "Storico delle variazioni"
	},
	"intro": "Almeno il 30% dei posti ammessi a finanziamento va a studenti con la tariffa DSU. Qui trovi i posti della quota 30% del bando e ogni variazione della quota.",
	"ministry": {
		"call_open": "La risposta si registra dopo la chiusura del bando.",
		"document": "Apri il documento",
		"download_failed": "Il documento non si è aperto. Riprova.",
		"none": "Nessuna risposta registrata. Se restano posti DSU scoperti, le offerte aspettano la risposta.",
		"record": {
			"action": "Carica la risposta del Ministero",
			"answer": "Che cosa ha risposto il Ministero?",
			"confirm": "Registra la risposta",
			"date": "Giorno della risposta",
			"denied": "No: i posti restano scoperti",
			"description": "Con il sì, i posti DSU rimasti scoperti vanno ai primi della lista della quota 70% senza posto DSU, a tariffa DSU. La risposta si registra una volta sola.",
			"document_hint": "Il PDF o l'email della risposta del Ministero.",
			"done": "Risposta registrata.",
			"future": "Il giorno non può essere nel futuro.",
			"granted": "Sì: i posti DSU scoperti vanno alla lista 70%",
			"title": "Risposta del Ministero"
		},
		"recorded": "Il Ministero ha risposto il {{day}}. Registrata da {{name}} il {{when}}.",
		"someone": "un utente",
		"state": {
			"denied": "No",
			"granted": "Sì",
			"none": "Nessuna risposta",
			"unlocked": "Offerte sbloccate"
		},
		"title": "Risposta del Ministero",
		"unlock": {
			"action": "Sblocca le offerte",
			"confirm": "Sblocca le offerte",
			"description": "Le offerte partono senza la risposta del Ministero e i posti DSU scoperti restano scoperti. Se la risposta arriva dopo, il gestore la registra e vale.",
			"done": "Offerte sbloccate.",
			"reason": "Motivo",
			"reason_hint": "Almeno {{min}} caratteri: resta nel registro.",
			"title": "Sblocca le offerte"
		},
		"unlocked": "Offerte sbloccate da {{name}} il {{when}}: {{reason}}"
	},
	"not_launched": "La quota DSU conta dall'avvio delle offerte: per questa struttura le offerte non sono ancora partite.",
	"not_set": "Non impostata",
	"page_title": "Quota DSU",
	"seats": {
		"beyond_one": "{{count}} posto oltre quelli del bando",
		"beyond_other": "{{count}} posti oltre quelli del bando",
		"name_missing": "Nome non indicato",
		"number": "Posto {{number}}",
		"protocol": "Protocollo {{protocol}}",
		"since": "Dal {{date}}",
		"state": {
			"covered": "Coperto",
			"in_progress": "Offerta in corso",
			"unassigned": "Da assegnare",
			"uncovered": "Non coperto"
		},
		"title": "Posti della quota 30%",
		"total_one": "{{count}} posto nel bando",
		"total_other": "{{count}} posti nel bando"
	}
}
